import React, { useState, useContext } from "react";
// @mui material components

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";

import SearchTherapistsReq from "../../../../Classes/Models/Requests/Administration/Types/CreateTherapistEmployeeTypeReq";
import AsyncSelect from "react-select/async";
import UsersApi from "../../../../Classes/API/UsersApi";
import { LanguageContext } from "App";
const AddTherapistTypeToSession = ({ Session, AddToSession, setIsLoaded }) => {
  const { translations } = useContext(LanguageContext);
  const [TypesSearch, setTypesSearch] = useState();
  const [TypeId, setTypeId] = useState("");
  const [Qty, setQty] = useState("");

  const GetTherapistTypes = async () => {
    let searchReq = new SearchTherapistsReq();
    searchReq.TypeName = TypesSearch;
    searchReq.Description = TypesSearch;
    searchReq.Category = TypesSearch;

    let res = await UsersApi.SearchTherapistTypes(searchReq);

    if (res.status == "Success") {
      // setTypes(res.data.list)
      let optionsArr = [];
      res.data.list.forEach((item) => {
        optionsArr.push({ value: item.id, label: item.typeName });
      });

      return optionsArr;
    }
  };

  return (
    <MDBox
      display="flex"
      justifyContent="space-between"
      py={1}
      pr={2}
      sx={{
        flexDirection: { xs: "column", sm: "row" },
      }}
    >
      {" "}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* <MDTypography
          variant="button"
          fontWeight="bold"
          textTransform="capitalize"
          className="ml-2 mb-2"
        >
          {translations.sessionPgSessionsAddTherapistTypes}: &nbsp;
        </MDTypography> */}

        {/* <MDTypography variant="button" fontWeight="regular" color="text" className="mx-2 mb-2">
          <AsyncSelect
            isClearable={true}
            styles={{
              container: (provided) => ({
                ...provided,
                width: "150px",
              }),
              menu: (provided) => ({
                ...provided,
                width: "150px",
              }),
            }}
            loadOptions={GetTherapistTypes}
            onInputChange={setTypesSearch}
            onChange={(e) => setTypeId(e ? e.value : "")}
            // value={TypeId}
          />
        </MDTypography> */}
      </div>
      <div style={{ display: "flex" }}>
        <MDTypography variant="button" fontWeight="regular" color="text" className="mx-2">
          <MDInput
            onChange={(e) => setQty(e.target.value)}
            label={translations.sessionPgSessionsQuantity}
            className={translations.setlang === "ar" ? "rtl-label" : ""}
          ></MDInput>
        </MDTypography>
        <MDTypography variant="button" fontWeight="regular" color="text">
          <button onClick={() => AddToSession(TypeId, Qty)} className="btn btn-success">
            +
          </button>
        </MDTypography>
      </div>
    </MDBox>
  );
};

export default AddTherapistTypeToSession;
